import { getObjectEntries } from '@hg-akademie-ban/vamos-viva-type-utils';
import { type Duration } from 'tinyduration';

export type DurationTimeUnit = keyof Pick<Duration, 'seconds' | 'minutes' | 'hours' | 'days' | 'weeks'>;

const timeUnitToSecondsMap: Record<DurationTimeUnit, number> = {
  seconds: 1,
  minutes: 60,
  hours: 60 * 60,
  days: 60 * 60 * 24,
  weeks: 60 * 60 * 24 * 7,
} as const;

export function durationToTimeUnit(duration: Duration, targetUnit: DurationTimeUnit) {
  if (duration.months || duration.years) {
    throw new Error('Durations with year or month component are not supported.');
  }

  let seconds = 0;
  for (const [key, multiplier] of getObjectEntries(timeUnitToSecondsMap)) {
    seconds += (duration[key] ?? 0) * multiplier;
  }

  return seconds / timeUnitToSecondsMap[targetUnit];
}
